import _, { isInteger } from 'lodash'

import { filterKeys, moreFilterOptions } from '../../configuration/filtering'

export function equal(filterValue, tourField) {
  return filterValue === tourField
}

export function inInclusiveRange({min, max}, value) {
  return (_.isInteger(min) && _.isInteger(max) && isInteger(value))
    ? _.inRange(value, min, max + 1)
    : true
}

export function exact(filterSet, tourField) {
  if (!_.isEmpty(filterSet)) {
    const uniqSortedFilterSet = _.sortBy(_.uniq(filterSet))
    const uniqueSortedTourField = _.sortBy(_.uniq(tourField))
    return _.isEqual(uniqSortedFilterSet, uniqueSortedTourField)
  }
  return true
}

export function every(filterSet, tourField) {
  return _.isEmpty(filterSet)
    || _.every(filterSet, filter => _.find(tourField, option => _.toLower(option) === _.toLower(filter)))
}

export function some(filterSet, tourField) {
  return _.isEmpty(filterSet)
    || _.some(filterSet, filter => Boolean(_.find(tourField, option => _.toLower(option) === _.toLower(filter))))
}

export function getHasMoreFiltersSelections(localFilterState) {
  let hasActiveSelections = false
  _.forEach(moreFilterOptions, filterType => {
    const isRangeFilterType = filterType === filterKeys.destinationCount
      || filterType === filterKeys.duration
    const hasRangeValuesSet = _.get(localFilterState, `[${filterType}].min`)
      && _.get(localFilterState, `[${filterType}].max`)
    if (isRangeFilterType) {
      if (hasRangeValuesSet) {
        hasActiveSelections = true
      }
    } else if (!_.isEmpty(localFilterState[filterType])) {
      hasActiveSelections = true
    }
  })
  return hasActiveSelections
}
